import request from "../utils/request.js";

export default {
	api(data) {
		//data.user = process.env.VUE_APP_LOYALTY_API_ACC;

		var form_data = new FormData();
		for ( var key in data ) {
			form_data.append(key, data[key]);
		}

		return request({
			method: "post",
			data: form_data
		})
	}
}